export default __webpack_public_path__ + "static/media/logo2.032575d6.jpg";